<template>

    <v-page-body>

        <v-page-section padded>
            <template #title>
                <span>{{ pagination | paginationTitle(`${group.name} (`, `)`) }}</span>
            </template>
            <template #body>
                <v-notice v-if="!members.length" title="No Members" message="There are no members yet." />
                <v-table v-else bordered>
                    <thead>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Date</th>
                    </thead>
                    <tbody>
                        <tr v-for="m in members" :key="m.id" @click="viewCustomer(m.customer_id)">
                            <td class="w-34 pr-0">
                                <v-avatar v-if="m.customer"
                                    :name="m.customer.initials"
                                    :color="m.customer.color"
                                    :url="m.customer.gravatar ? m.customer.gravatar + '&s=80' : ''"
                                    :size="34"
                                    :radius="17">
                                </v-avatar>
                            </td>
                            <td><v-value :value="m.customer | valueForTrait({ field: 'name', type: 'string' })" /></td>
                            <td><v-value :value="m.customer | valueForTrait({ field: 'email', type: 'string', format: 'email' })" /></td>
                            <td>{{ m.created_at | dateTime }}</td>
                        </tr>
                    </tbody>
                </v-table>
            </template>
            <template #footer>
                <v-pagination :count="pagination.last_page" @search="paginateMembers($event)" />
            </template>
        </v-page-section>

    </v-page-body>

</template>

<script>

import axios from 'axios';
import UnsubGroupApi from '@api/UnsubGroupApi';

export default {

    data() {
        return {
            group: null,
            members: [],
            pagination: {},
        }
    },

    mounted() {
        this.params = this.$route.query;
        this.reload();
    },

    watch: {

        $route(val) {
            this.params = val.query;
            this.reload();
        },

    },

    methods: {

        reload() {
            this.$store.commit('loading', true);
            let requests = [
                UnsubGroupApi.getUnsubGroup(this.$route.params.id, this.params),
                UnsubGroupApi.getMembers(this.$route.params.id, this.params),
            ];
            axios.all(requests)
                .then(axios.spread((resGroup, resMembers) => {
                    this.$store.commit('loading', false);
                    this.group = resGroup.data.data;
                    this.members = resMembers.data.data;
                    this.pagination = resMembers.data.pagination;
                    this.$events.$emit('pageLoaded');
                }), () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        paginateMembers(page) {
            let query = Object.assign({}, this.$route.query);
            query.page = page;
            this.$router.replace({ query: query }).catch(() => {});
        },

        viewCustomer(customerId) {
            this.$router.push({
                name: 'customer',
                params: { id: customerId },
            });
        },

    },

}

</script>